module.exports = __webpack_public_path__ + "img/code.e63e8999.svg";